import { FormControl, InputBase, MenuItem, Select } from '@material-ui/core'
import React, { memo } from 'react'



const Tablefilters = memo(({ name, options = [], handleChange, defaultValue = "", placeholder }) => (
    <FormControl size="medium" className="filter" style={{ marginRight: "15px" }}>
        <Select
            fullWidth
            displayEmpty
            defaultValue={defaultValue}
            onChange={(e) => handleChange(name, e.target.value)}
            input={<InputBase />}
        >
            {placeholder && <MenuItem value="">{placeholder}</MenuItem>}
            {options.map(({ id, value, name, label }) => (
                <MenuItem key={id || value} value={id || value}>
                    {name || label}
                </MenuItem>
            ))}
        </Select>
    </FormControl>
));



export default Tablefilters